// extracted by mini-css-extract-plugin
export var collapsedSummary = "_sd-0";